import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Tab, TabId } from '../menu.types';

@Component({
  selector: 'app-category-tabs',
  imports: [TranslatePipe],
  template: `
    <nav
      class="qm-tabs border-b border-slate-100 bg-white/80 shadow-sm backdrop-blur-md"
      [attr.aria-label]="'menu.categoriesNav' | translate"
    >
      <div class="qm-tabrow no-scrollbar mx-auto flex max-w-md items-center gap-2 overflow-x-auto scroll-smooth px-6 py-4 motion-reduce:scroll-auto">
        @for (tab of tabs(); track tab.id) {
          @let active = selected() === tab.id;
          <button
            type="button"
            (click)="onSelect(tab.id, $event)"
            [attr.aria-current]="active ? 'true' : null"
            class="qm-tab whitespace-nowrap rounded-full px-5 py-2 text-sm font-semibold transition-all duration-300"
            [class.qm-tab--active]="active"
            [class.shadow-md]="active"
            [class.scale-105]="active"
            [class.bg-slate-100]="!active"
            [class.text-slate-600]="!active"
            [class.hover:bg-slate-200]="!active"
            [style.text-shadow]="active ? '0 1px 2px rgba(0,0,0,0.5)' : null"
            [style.background]="active ? 'var(--qm-accent)' : null"
            [style.color]="active ? 'var(--qm-accent-fg)' : null"
          >
            {{ tab.name }}
          </button>
        }
      </div>
    </nav>
  `,
  styles: `
    :host {
      position: sticky;
      top: 0;
      z-index: 50;
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryTabs {
  tabs = input.required<Tab[]>();
  selected = input.required<TabId>();
  selectTab = output<TabId>();

  onSelect(id: TabId, event: Event): void {
    this.selectTab.emit(id);
    const button = event.currentTarget;
    if (button instanceof HTMLElement) {
      button.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
  }
}
